import { FaCheckCircle, FaTags, FaBusinessTime, FaHandshake, FaLayerGroup, FaShieldAlt } from 'react-icons/fa'

const whyChooseUsData = [
    {
        id: 1,
        title: "Quality Assurance",
        description: "Strict quality checks ensure consistent performance and reliability.",
        icon: <FaShieldAlt />
    },
    {
        id: 2,
        title: "Reliable Sourcing",
        description: "We deliver chemicals that meet required specifications and industry standards.",
        icon: <FaCheckCircle />
    },
    {
        id: 3,
        title: "Competitive Pricing",
        description: "Strong supplier networks allow us to offer the best market prices.",
        icon: <FaTags />
    },
    {
        id: 4,
        title: "Industry Experience",
        description: "Backed by years of collaboration with leading chemical firms.",
        icon: <FaBusinessTime />
    },
    {
        id: 5,
        title: "Customer-First Approach",
        description: "We focus on long-term relationships through consistent service.",
        icon: <FaHandshake />
    },
    {
        id: 6,
        title: "Wide Product Range",
        description: "Catering to multiple industries with a diverse chemical portfolio.",
        icon: <FaLayerGroup />
    }
];

export default whyChooseUsData;